
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mercado-livre-de-energia",
      function () {
        return require("private-next-pages/mercado-livre-de-energia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mercado-livre-de-energia"])
      });
    }
  